// extracted by mini-css-extract-plugin
export default {"confirmWrapper":"style_confirmWrapper__uQ-Mp","congratulations":"style_congratulations__jF6gh","thankYou":"style_thankYou__WwDZv","arrowRightIcon":"style_arrowRightIcon__O0NCe"};